import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get_profile_list } from '../../../store/profile/profileSlice';
import {
  Paper,
  TextField,
  Stack,
  Button,
  Grid,
} from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';

function ProfileTable({ handleProfileModal, handleProfileUpdate, profile_list, user_id, page }) {
  const dispatch = useDispatch();
  const [is_editing, setIsEditing] = useState(false);

  const loggedInUser = useSelector((state) => state.auth.user);
  const profile_id = loggedInUser?.id;

  // Validation schema
  const validationSchema = yup.object().shape({
    first_name: yup.string().trim().required('First name is required.'),
    last_name: yup.string().trim().required('Last name is required.'),
    email: yup.string().trim().required('Email is required.'),
    contact_no: yup.string().trim().required('Contact number is required.'),
  });

  // Initial values
  const initialValues = {
    first_name: profile_list?.first_name || '',
    last_name: profile_list?.last_name || '',
    email: profile_list?.email || '',
    contact_no: profile_list?.contact_no || '',
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try {

        const res_update = await handleProfileUpdate({
          user_id: user_id,
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          contact_no: values.contact_no,
        });

        if (res_update) {
          formik.resetForm();
          setIsEditing(false);
          handleProfileModal(false);
          window.location.reload();
        }
      } catch (err) {
        console.error("Profile update failed:", err);
      }
    },
  });

  const handleEditClick = () => setIsEditing(true);
  const handleCancelClick = () => {
    setIsEditing(false);
    formik.resetForm();
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", p: { xs: 2, sm: 3, md: 4 } }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={6}>
            <TextField
              label="First Name"
              variant="outlined"
              size="small"
              fullWidth
              name="first_name"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.first_name && Boolean(formik.errors.first_name)}
              helperText={formik.touched.first_name && formik.errors.first_name}
              disabled={!is_editing}
            />
          </Grid>
          <Grid item xs={12} sm={6}>

            <TextField
              label="Last Name"
              variant="outlined"
              size="small"
              fullWidth
              name="last_name"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.last_name && Boolean(formik.errors.last_name)}
              helperText={formik.touched.last_name && formik.errors.last_name}
              disabled={!is_editing}
            />

          </Grid>
          <Grid item xs={12} sm={6}>

            <TextField
              label="Email"
              variant="outlined"
              size="small"
              fullWidth
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              disabled={!is_editing}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Contact Number"
              variant="outlined"
              size="small"
              fullWidth
              name="contact_no"
              value={formik.values.contact_no}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.contact_no && Boolean(formik.errors.contact_no)}
              helperText={formik.touched.contact_no && formik.errors.contact_no}
              disabled={!is_editing}
            />
          </Grid>
        </Grid>

        <Stack direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{ mt: 3 }}>
          {is_editing ? (
            <>
              <Button variant="contained" color="primary" onClick={formik.handleSubmit}
                sx={{ backgroundColor: "#ff6100" }}>
                Save
              </Button>
              <Button variant="outlined" color="secondary" onClick={handleCancelClick}
                sx={{ borderColor: "#ff6100", color: "#4c4e52" }}>
                Cancel
              </Button>
            </>
          ) : (
            <Button variant="contained" onClick={handleEditClick}
              sx={{ backgroundColor: "#ff6100" }}>
              Edit
            </Button>
          )}
        </Stack>
      </form>
    </Paper>
  );
}

export default ProfileTable;
